import React from "react";
import ProductIcon from "./ProductIcons";

export default function FeatureCard({ icon, title, body, label, className = "" }) {
  return (
    <article
      className={[
        "rounded-2xl border border-ink/8 bg-white p-5 shadow-card md:p-6",
        className,
      ].join(" ")}
    >
      {icon ? (
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-hint/12 text-hint-deep">
          <ProductIcon name={icon} />
        </span>
      ) : null}
      <h3 className="mt-4 text-base font-semibold tracking-tight text-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-muted">{body}</p>
      {label ? (
        <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.18em] text-muted/70">
          {label}
        </p>
      ) : null}
    </article>
  );
}
